import React from 'react';
import { mdiEye, mdiEyeOff } from '@mdi/js';
import Icon from '@mdi/react';
import { IconSize } from '../../../lib';
const PublicIndicator = ({ isPublic }) => {
    return React.createElement(Icon, { path: isPublic ? mdiEye : mdiEyeOff, size: IconSize.Small });
};
export default PublicIndicator;
//# sourceMappingURL=index.js.map